module.exports = __webpack_public_path__ + "static/media/22_WMATA - Washington, DC.dda255fc.jpg";